import { defineStore } from "pinia";

import { Organization } from '@/users';

export const useUserStore = defineStore("user", {
    state: () => {
        return {
            uuid: null,
            email: null,
            first_name: null,
            last_name: null,
            family: null,
            rights: [],
            is_manager: false,
            can_export_report_sheet_summaries: false,
            has_password: false,
            loaded: false,
            organizations: [],
            current_organization: null,
            profile_picture: null,
        } as {
            uuid: string | null;
            email: string | null;
            first_name: string | null;
            last_name: string | null;
            family: string | null;
            is_manager: boolean;
            can_export_report_sheet_summaries: boolean;
            rights: string[];
            has_password: boolean;
            loaded: boolean;
            organizations: Organization[];
            current_organization: Organization | null;
            profile_picture: string | null;
        };
    },
    getters: {
        is_logged_in: (state) => {
            return !!state.email;
        },
        display_name: (state) =>
            state.first_name && state.last_name
                ? state.first_name + " " + state.last_name
                : state.email,
        // Driven by backend config (travexploit.global_managers)
        isManager: (state) => state.is_manager,
        // The summaries PDF export: the CDG plus the users pinned in
        // travexploit.report_sheet_summary_exporters — not manager access.
        canExportSummaries: (state) => state.can_export_report_sheet_summaries,
        hasRight: (state) => (right: string) => {
            return state.rights.includes(right);
        },
        getValue: (state) => (key: string) => {
            return (state as any)[key] ?? null;
        },
    },
});
